<template>
  <div class="">
    <div class="condition clearfix" id="">
      <el-form :inline="true" :model="conditions" class="demo-form-inline clearfix" ref="conditions">
        <div class="clearfix" style="margin-bottom: 10px;">
          <!-- search start-->
           <el-form-item label="销售单号：" class="tinp">
                    <el-input v-model="conditions.vbillcode" placeholder="请输入申请单号" suffix-icon="el-icon-search" clearable  ></el-input>
                </el-form-item>
     	   <el-form-item label="商品编码：" class="tinp">
		        <el-input v-model="conditions.productCode" placeholder="请输入商品编码" suffix-icon="el-icon-search" clearable ></el-input>
		      </el-form-item>
		     <!--  <el-form-item label="商品名称：" class="tinp">
		        <el-input v-model="conditions.productName" placeholder="请输入商品名称" suffix-icon="el-icon-search" clearable @change="onParamChange"></el-input>
		   </el-form-item> -->
           <el-form-item label="销售日期：" class="tinp searchtime":class="{iconshow:showicon}">
               <el-date-picker value-format="yyyy-MM-dd" v-model="conditions.time" type="date" placeholder="选择日期"   @mouseover.native="cleandataicon" @mouseout.native="cleandataicon" >
              </el-date-picker>
            </el-form-item>
          <el-button type="primary" class="" style="margin-left: 20px" size="small" icon="el-icon-search" @click="onParamChange" v-loading.fullscreen.lock="fullscreenLoading">搜索</el-button>
          <el-button type="primary" class="fr" style="margin-right: 20px" size="small" icon="el-icon-plus" @click="addlist">新增出库货品单 </el-button>
        </div>
        <!-- tablelist1 start -->
        <div class="tablebox" style="margin-top: 0px;" v-if="count >=1">
          <table style="width: 1146px !important;margin-bottom:16px" v-for="(item,index) in tableList">
            <tr style="border: 1px solid #56B8AA;background:#fff;color: #333;height:45px">
              <th :id="item.vbillcode" style="width:2rem;font-color:#56B8AA;background-color:#fff;position:relative" @click="showlist(item,index)">
                <i class="iconfont icon-jiantou_yemian_xiangshang jiantouxia" v-bind:class="{'jiantoushang':item.listshow =='N'}" style="color: #56B8AA;font-size: 22px;font-weight: 100;"></i></th>
              <th colspan="11">
                <span class="fl tabletitle">销售出库单号：{{item.vbillcode}}</span>
                <span class="fl tabletitle">销售出库日期：{{item.dbilldate}}</span>
                <span class="fr tabletitle">制单人：{{item.billmakername}}</span>
                <!-- <span class="fr tabletitle">价税合计：{{item.ntotaltaxmny}}</span>  -->
                </th>
            </tr>
            <tr style="border: 1px solid #56B8AA;background: #56B8AA;color: #fff;height:45px" v-show="item.listshow =='N'">
              <th style="width:">行号</th>
              <th style="border: 1px solid rgb(86, 184, 170);" v-for="head in tableHeads">{{ head.label }}</th>
            </tr>
            <tr class="trbg" v-for="(data,index2) in item.productList" :key="item.pkApplybillB" v-show="item.listshow =='N'">
              <td style="border: 1px solid #56B8AA; height: 38px;">{{index2+1}}</td>
              <td v-for="head in tableHeads" style="border: 1px solid #56B8AA; height: 38px;">
                <span>{{data[head.key]}}</span>
              </td>
            </tr>
          </table>
        </div>
        <!-- tablelist1 end -->
        <div class="msgNone" v-else style="text-align: center;font-size: 15px;color: #333;margin-top: 20px">
          暂无数据
        </div>
        <!-- fenye start -->
        <div class="block" style="text-align: center;margin:20px auto ">
          <span>
            <el-pagination class="fenye" @size-change="handleSizeChange" @current-change="handleCurrentChange"  background
              :current-page="page"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="count">
            </el-pagination>
            </span>
        </div>
        <!-- fenye end -->
      </el-form>
    </div>
    <!-- model end -->
    <div class="" v-loading.fullscreen.lock="fullscreenLoading"></div>
   <!-- 弹窗 start -->
      <MessageModel types="提示信息" :msg="msg" :msgShow="msgShow" :flag="modelFlag" :butmsg="butmsg" :butflag = "butflag" @modelmsg="returnMsg"></MessageModel>
  </div>
</template>
<script>
import { getElementsByClassName } from '../../../static/js/cookie.js'
export default {
  name: '',
  data() {
    return {
      flag:false,
      modelFlag:false,
      msgShow:false,
      modelFlag2:false,
      butflag:true,
      butflag2:true,
      msg:'',
      butmsg:'确认',
      butmsg2:'确认',
      methodName:'',
      utilpath: '',
      page: 1,
      pagesize: 10,
      count: 0,
      id: '',
      index: 0,
      user: {},
      fullscreenLoading: false,
      showicon: false,
      conditions: {
        vbillcode: '', //销售单号
        productCode: '', //商品编码
        productName: '', //商品名称
        time: '', //销售日期
      },
      tableList: [],
      tableHeads: [
        // {
        //        label: '退货仓库',
        //        key: 'repertoryname'
        //    },
        // {
        //        label: '退货货位',
        //        key: 'positionname'
        //    },
        {
          label: '商品编码',
          key: 'productCode'
        },
        {
          label: '商品名称',
          key: 'productName'
        },
        {
          label: '规格',
          key: 'wlspec'
        },
        {
          label: '型号',
          key: 'wltype'
        },
        {
          label: '主单位',
          key: 'cunitname'
        },
        // {
        //     label: '批次号',
        //     key: 'vbatchcode'
        // },
        {
          label: '销售数量',
          key: 'nznum'
        },
        // {
        //   label: '单价',
        //   key: 'nprice'
        // },
        // {
        //   label: '合计',
        //   key: 'ntaxmny'
        // },
      ],
      InterfacePath: ''
    }
  },
  mounted() {
    // 获取接口名
    this.InterfacePath = window.localStorage.getItem("InterfacePath");
    this.utilpath = this.axios.defaults.baseURL;
    this.init();
  },
  destroyed() {
    sessionStorage.removeItem("vbillcode");
    sessionStorage.removeItem("productCode");
    sessionStorage.removeItem("productName");
    sessionStorage.removeItem("time");
    sessionStorage.removeItem("page");
    sessionStorage.removeItem("pagesize");
    sessionStorage.removeItem("xiaolist");
    //console.log("清除session");
  },
  methods: {
    returnMsg(flag){
      this.modelFlag = false;
      if(flag){
             //console.log("---进来了！！！----"+this.methodName);
            if(this.methodName =='---'){
                var reqparams={
                  storecode:this.user.storecode,
                  productCode:this.productCode
                }
                // console.log("---参数！！！----"+JSON.stringify(this.reqparams));
                this.$http.post(this.utilpath+'/delettePrabillB',reqparams,{emulateJSON:true,_timeout:600}).then((res)=>{
                    if(res.data.status == '0'){

                    } else if(res.data.status == '9'){
                      this.fullscreenLoading =false;
                      this.$router.push({path:'/ui/login',query:{msg:9}});
                    } else{
                      this.modelFlag = true;
                      this.msgShow = true;
                      this.methodName = 'message';
                      this.msg = res.data.message;
                      this.butflag =false;
                      this.butmsg='知道了';
                      //  this.$alert('门店请购单信息删除失败', '失败信息', {
                      //   confirmButtonText: '确定'
                      // });
                    }
                }, (err) => {
                  this.modelFlag = true;
                  this.msgShow = false;
                  this.methodName = 'message';
                  this.msg = '获取接口失败'+err;
                  this.butflag =false;
                  this.butmsg='知道了';
                })
            }
      }else{
        this.$message({
          showClose:true,
          message:'已取消',
          type:'succcess'
        })
      }
    },
    //显示隐藏表格
    showlist(item, index) {
      //console.log("展开方法");
      // 取反(true或false)
      this.tableList[index].listshow = item.listshow == 'Y' ? 'N' : 'Y';
      for (var i = 0; i < this.tableList.length; i++) {
        if (i != index) {
          this.tableList[i].listshow = 'N';
        }
      }
      this.id = item.vbillcode;
      this.toTop();
    },
    toTop() {
      var idmsg = '';
      if (this.id != '') {
        idmsg = this.id;
      } else {
        idmsg = 'contain';
      }
      //参数i表示间隔的幅度大小，以此来控制速度
      var dis = (document.getElementById(idmsg).scrollTop) / 8
      this.step = dis;
      document.getElementById(idmsg).scrollTop -= dis;
      var scroll = document.getElementById(idmsg).scrollTop;
      if (scroll > 0) {
        // console.log("回到顶部循环内" + document.getElementById(idmsg).scrollTop);
        this.step += dis
        var c = setTimeout(() => this.toTop(this.step), 16);
      } else {
        clearTimeout(c);
      }
    },
    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.pagesize = val;
      this.page=1;
      // this.getList();
      //console.log(this.pagesize);
    },
    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.page = val;
      //console.log(this.page);
      this.fullscreenLoading = true;
      this.getList();
    },
    addlist() {
      this.$router.push({ path: '/ui/stock/xiaochu/zengxiao' });
    },
    cleandataicon() {
      if (this.conditions.time != '') {
        this.showicon = !this.showicon;
      }
      if (this.conditions.time == null) {
        this.showicon = false;
      }
    },
    //获取数据this.buyType==''?0:this.buyType
    getList() {
      var reqParam = {
        storecode: this.user.storecode,
        vbillcode: this.conditions.vbillcode,//销售单号
        fbillstatus: '1', //单据状态
        productCode: this.conditions.productName, //商品名称
        productName: this.conditions.productName, //商品名称
        time: this.conditions.time, //销售日期
        pageNum: this.page, //当前页
        pageSize: this.pagesize //页面数据条数
      }
      sessionStorage.setItem("vbillcode", this.conditions.vbillcode);
      sessionStorage.setItem("statu", JSON.stringify(this.conditions));
      sessionStorage.setItem("productCode", this.conditions.productCode);
      sessionStorage.setItem("productName", this.conditions.productName);
      sessionStorage.setItem("time", this.conditions.time);
      sessionStorage.setItem("page", this.page);
      sessionStorage.setItem("pagesize", this.pagesize);
      //获取数据接口
      // this.$http.post('api/goods', reqParam).then((res) => {
      // this.$http.post(this.InterfacePath+"/ktnapi/selectReturnbill",reqParam,{emulateJSON:true}).then((res)=>{
      this.$http.post(this.utilpath + '/selectSaleInfo', reqParam, { emulateJSON: true,_timeout:600}).then((res) => {
        // this.$http.post("ktnapi/selectApplyBill",reqParam,{emulateJSON:true}).then((res)=>{
        if (res.data.status == '0') {
          this.fullscreenLoading = false;
          // this.tableList=res.data.result;
          this.tableList = res.data.resultList;
          this.count = res.data.countNum;
          sessionStorage.setItem("xiaolist", JSON.stringify(this.tableList));
        } else if (res.data.status == '-1') {
          this.fullscreenLoading = false;
          this.count = 0;
          this.tableList=[];
          this.$message({
            showClose:true,
            message:'暂无数据！',
            type:'info'
          })
        } else if(res.data.status == '9'){
          this.fullscreenLoading =false;
          this.$router.push({path:'/ui/login',query:{msg:9}});
        } else {
          this.fullscreenLoading = false;
          this.modelFlag = true;
          this.msgShow = true;
          this.methodName = 'message';
          this.msg = res.data.message;
          this.butflag =false;
          this.butmsg='知道了';
        }
      }, (err) => {
        this.fullscreenLoading = false;
        this.msgShow = false;
        this.modelFlag = true;
        this.methodName = 'message';
        this.msg = '连接查询门店退货单接口失败';
        this.butflag =false;
        this.butmsg='知道了';
      });
    },
    init() {
      this.user = JSON.parse(window.localStorage.getItem("userInfo"));
      var inp1 = sessionStorage.getItem("vbillcode");
      var inp2 = JSON.parse(sessionStorage.getItem("statu"));
      var inp5 = sessionStorage.getItem("productCode");
      var inp3 = sessionStorage.getItem("productName");
      var inp4 = sessionStorage.getItem("time");
      if (inp1 != null) {
        this.conditions.vbillcode = inp1;
      }
      if (inp2 != null) {
        this.conditions = inp2;
      }
      if (inp3 != null) {
        this.conditions.productName = inp3;
      }
      if (inp4 != null) {
        this.conditions.time = inp4;
      }
      if (inp5 != null) {
        this.conditions.productCode = inp5;
      }
      var bigdata = JSON.parse(sessionStorage.getItem("xiaolist"));
      // console.log("初始化打印数据："+JSON.stringify(bigdata));
      if (bigdata != null) {
        this.fullscreenLoading =false;
        this.tableList = bigdata;
        this.count = this.tableList.length;
        this.page = parseFloat(sessionStorage.getItem("page"));
        this.pagesize = parseFloat(sessionStorage.getItem("pagesize"));
      } else {
        // this.getList();
      }
    },
    //搜索框变化事件
    onParamChange() {
      this.page = 1;
      this.getList();
    }
  }
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/stock/xiaochu.vue